import { ServerCog } from 'lucide-react'

import { DISTRIBUTION_SYSTEM_COPY } from '#app/routes/mocra+/_form+/components/distribution-systems/constants.ts'
import {
	distributionSystemCardTitle,
	formatDistributionSystemSummary,
	type DistributionSystemDraft,
} from '#app/routes/mocra+/_form+/components/distribution-systems/types.ts'
import { EntityCard } from '#app/routes/mocra+/_form+/components/entity-card.tsx'

type Props = {
	readonly system: DistributionSystemDraft
	readonly onEdit: () => void
	readonly onRemove?: () => void
	readonly removeDisabled?: boolean
	readonly errors?: readonly string[]
}

export function DistributionSystemCard({
	system,
	onEdit,
	onRemove,
	removeDisabled,
	errors,
}: Props) {
	const title = distributionSystemCardTitle(system)
	const summary = formatDistributionSystemSummary(system)
	const hasErrors = Boolean(errors && errors.length > 0)
	const description = hasErrors ? `${summary} • Needs attention` : summary

	return (
		<EntityCard
			title={title}
			description={description}
			onEdit={onEdit}
			onRemove={onRemove}
			removeDisabled={removeDisabled}
			removeLabel="Remove"
			removeConfirmTitle={DISTRIBUTION_SYSTEM_COPY.actions.removeConfirmTitle}
			removeConfirmDescription={
				DISTRIBUTION_SYSTEM_COPY.actions.removeConfirmDescription
			}
			icon={
				<ServerCog
					className="text-muted-foreground h-3.5 w-3.5"
					aria-hidden="true"
				/>
			}
			className={
				hasErrors
					? 'border-destructive/40 ring-destructive/40 ring-1'
					: undefined
			}
			removeAriaLabel="Remove distribution system"
		/>
	)
}
